import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router";

import { guide } from "./routes";

// eslint-disable-next-line import/prefer-default-export
export const UnauthorizedOnlyRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return localStorage.getItem("token") ? (
          <Redirect
            to={{
              pathname: guide,
              state: { from: props.location }
            }}
          />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

UnauthorizedOnlyRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.any
  ]).isRequired,
  location: PropTypes.shape({})
};

UnauthorizedOnlyRoute.defaultProps = {
  location: {}
};
